export const SERVICE_CATALOG = [
  { 
    type: "groomer", 
    title: "Groomer", 
    species: ["canine", "feline"],
    image: "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=400&h=300&fit=crop"
  },
  { 
    type: "farrier", 
    title: "Farrier", 
    species: ["equine"],
    image: "https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=400&h=300&fit=crop"
  },
  { 
    type: "trainer", 
    title: "Trainer", 
    species: ["canine", "feline", "equine"],
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=300&fit=crop"
  },
  { 
    type: "boarding", 
    title: "Boarding", 
    species: ["canine", "feline", "equine"],
    image: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=400&h=300&fit=crop"
  },
  { 
    type: "transport", 
    title: "Transport", 
    species: ["canine", "feline", "equine", "cattle", "exotics"],
    image: "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=400&h=300&fit=crop"
  },
  { 
    type: "veterinary", 
    title: "Veterinary", 
    species: ["canine", "feline", "equine", "cattle", "exotics"],
    image: "https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?w=400&h=300&fit=crop"
  },
];
